// This file contains our custom data types that we use in our Protobuf payloads.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file common/protos/types.proto (package aurora.core.common.protos, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Benchmark } from "../../consts/benchmarkconsts_pb";
import { file_consts_benchmarkconsts } from "../../consts/benchmarkconsts_pb";
import type { Side } from "../../consts/commonconsts_pb";
import { file_consts_commonconsts } from "../../consts/commonconsts_pb";
import type { SecurityCategory, SecurityType } from "../../consts/instrumentconsts_pb";
import { file_consts_instrumentconsts } from "../../consts/instrumentconsts_pb";
import type { SettlementType } from "../../consts/settlementconsts_pb";
import { file_consts_settlementconsts } from "../../consts/settlementconsts_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/protos/types.proto.
 */
export const file_common_protos_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_consts_benchmarkconsts, file_consts_commonconsts, file_consts_instrumentconsts, file_consts_settlementconsts]);

/**
 * @generated from message aurora.core.common.protos.PbDecimal
 */
export type PbDecimal = Message<"aurora.core.common.protos.PbDecimal"> & {
  /**
   * @generated from field: int32 sign = 1;
   */
  sign: number;

  /**
   * @generated from field: int32 exponent = 2;
   */
  exponent: number;

  /**
   * @generated from field: bytes coefficient = 3;
   */
  coefficient: Uint8Array;
};

/**
 * Describes the message aurora.core.common.protos.PbDecimal.
 * Use `create(PbDecimalSchema)` to create a new message.
 */
export const PbDecimalSchema: GenMessage<PbDecimal> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 0);

/**
 * @generated from message aurora.core.common.protos.PbDate
 */
export type PbDate = Message<"aurora.core.common.protos.PbDate"> & {
  /**
   * @generated from field: int32 year = 1;
   */
  year: number;

  /**
   * @generated from field: int32 month = 2;
   */
  month: number;

  /**
   * @generated from field: int32 day = 3;
   */
  day: number;
};

/**
 * Describes the message aurora.core.common.protos.PbDate.
 * Use `create(PbDateSchema)` to create a new message.
 */
export const PbDateSchema: GenMessage<PbDate> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 1);

/**
 * @generated from message aurora.core.common.protos.PbCompanyInfo
 */
export type PbCompanyInfo = Message<"aurora.core.common.protos.PbCompanyInfo"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string company_name = 2;
   */
  companyName: string;

  /**
   * @generated from field: string nscc_account_id = 3;
   */
  nsccAccountId: string;

  /**
   * @generated from field: string display_id = 4;
   */
  displayId: string;

  /**
   * @generated from field: optional string preferred_collateral_rate = 5;
   */
  preferredCollateralRate?: string;

  /**
   * @generated from field: optional string cut_off_time = 6;
   */
  cutOffTime?: string;

  /**
   * @generated from field: repeated aurora.core.consts.settlement.SettlementType enabled_settlement_types = 7;
   */
  enabledSettlementTypes: SettlementType[];

  /**
   * @generated from field: aurora.core.common.protos.PbTradingPermissions trading_permissions = 8;
   */
  tradingPermissions: PbTradingPermissions;
};

/**
 * Describes the message aurora.core.common.protos.PbCompanyInfo.
 * Use `create(PbCompanyInfoSchema)` to create a new message.
 */
export const PbCompanyInfoSchema: GenMessage<PbCompanyInfo> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 2);

/**
 * @generated from message aurora.core.common.protos.PbActioningUser
 */
export type PbActioningUser = Message<"aurora.core.common.protos.PbActioningUser"> & {
  /**
   * @generated from field: string user_identifier = 1;
   */
  userIdentifier: string;

  /**
   * @generated from field: aurora.core.common.protos.UserType user_type = 3;
   */
  userType: UserType;

  /**
   * @generated from field: string public_identifier = 4;
   */
  publicIdentifier: string;
};

/**
 * Describes the message aurora.core.common.protos.PbActioningUser.
 * Use `create(PbActioningUserSchema)` to create a new message.
 */
export const PbActioningUserSchema: GenMessage<PbActioningUser> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 3);

/**
 * @generated from message aurora.core.common.protos.PbActioningUserWithSide
 */
export type PbActioningUserWithSide = Message<"aurora.core.common.protos.PbActioningUserWithSide"> & {
  /**
   * @generated from field: string user_identifier = 1;
   */
  userIdentifier: string;

  /**
   * @generated from field: aurora.core.consts.common.Side side = 2;
   */
  side: Side;

  /**
   * @generated from field: aurora.core.common.protos.UserType user_type = 4;
   */
  userType: UserType;

  /**
   * @generated from field: string public_identifier = 5;
   */
  publicIdentifier: string;
};

/**
 * Describes the message aurora.core.common.protos.PbActioningUserWithSide.
 * Use `create(PbActioningUserWithSideSchema)` to create a new message.
 */
export const PbActioningUserWithSideSchema: GenMessage<PbActioningUserWithSide> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 4);

/**
 * @generated from message aurora.core.common.protos.PbAgreementInfo
 */
export type PbAgreementInfo = Message<"aurora.core.common.protos.PbAgreementInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_id = 2;
   */
  displayId: string;

  /**
   * @generated from field: string short_name = 3;
   */
  shortName: string;
};

/**
 * Describes the message aurora.core.common.protos.PbAgreementInfo.
 * Use `create(PbAgreementInfoSchema)` to create a new message.
 */
export const PbAgreementInfoSchema: GenMessage<PbAgreementInfo> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 5);

/**
 * Instruments can be identified by their CUSIP or Ticker Symbol
 *
 * @generated from message aurora.core.common.protos.PbInstrument
 */
export type PbInstrument = Message<"aurora.core.common.protos.PbInstrument"> & {
  /**
   * CUSIP
   *
   * @generated from field: string cusip = 1;
   */
  cusip: string;

  /**
   * Ticker
   *
   * @generated from field: string ticker = 2;
   */
  ticker: string;

  /**
   * Security name
   *
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message aurora.core.common.protos.PbInstrument.
 * Use `create(PbInstrumentSchema)` to create a new message.
 */
export const PbInstrumentSchema: GenMessage<PbInstrument> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 6);

/**
 * Instrument details
 *
 * @generated from message aurora.core.common.protos.PbInstrumentInfo
 */
export type PbInstrumentInfo = Message<"aurora.core.common.protos.PbInstrumentInfo"> & {
  /**
   * A **CUSIP** number is a unique identification number assigned to stocks and registered bonds in the United States and Canada.
   * It comprises nine characters and includes letters and numbers.
   * Example: use `02079K305` for `Alphabet Inc` (formerly known as Google)
   *
   * @generated from field: string cusip = 1;
   */
  cusip: string;

  /**
   * A stock symbol (*ticker*) is an arrangement of characters (*usually letters*) representing publicly-traded securities on an exchange.
   * When a company issues securities to the public marketplace, it selects an available symbol for its shares, often related to the company name.
   * Example: use `AAPL` for `Apple Computers Inc.`
   *
   * @generated from field: string ticker = 2;
   */
  ticker: string;

  /**
   * Name of the instrument
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Type of Security (Common Stock, Preferred Stock, ...)
   *
   * @generated from field: aurora.core.consts.instruments.SecurityType security_type = 8;
   */
  securityType: SecurityType;

  /**
   * Last close price (not always provided)
   *
   * @generated from field: optional string last_close_price = 4;
   */
  lastClosePrice?: string;

  /**
   * Reason why instruments is (temporarily) disabled from trading
   *
   * @generated from field: optional string cannot_trade_message = 5;
   */
  cannotTradeMessage?: string;

  /**
   * Currency of the last close price of the instrument
   *
   * @generated from field: optional aurora.core.common.protos.Currency price_currency = 6;
   */
  priceCurrency?: Currency;

  /**
   * DB ID (not always provided)
   *
   * @generated from field: optional string id = 7;
   */
  id?: string;

  /**
   * UNDOCUMENTED for now - last price we got from Polygon
   *
   * @generated from field: optional string last_price = 9;
   */
  lastPrice?: string;

  /**
   * UNDOCUMENTED for now - timestamp we got the price update from Polygon
   *
   * @generated from field: optional string last_price_at = 10;
   */
  lastPriceAt?: string;

  /**
   * Category of Security (Equity, Fixed Income)
   *
   * @generated from field: aurora.core.consts.instruments.SecurityCategory security_category = 11;
   */
  securityCategory: SecurityCategory;

  /**
   * ISIN of the instrument
   *
   * @generated from field: optional string isin = 12;
   */
  isin?: string;
};

/**
 * Describes the message aurora.core.common.protos.PbInstrumentInfo.
 * Use `create(PbInstrumentInfoSchema)` to create a new message.
 */
export const PbInstrumentInfoSchema: GenMessage<PbInstrumentInfo> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 7);

/**
 * @generated from message aurora.core.common.protos.PbRateDetails
 */
export type PbRateDetails = Message<"aurora.core.common.protos.PbRateDetails"> & {
  /**
   * required
   *
   * @generated from field: string rate = 1;
   */
  rate: string;

  /**
   * Benchmark id used to calculate benchmark based
   *
   * @generated from field: optional aurora.core.consts.benchmark.Benchmark benchmark = 2;
   */
  benchmark?: Benchmark;
};

/**
 * Describes the message aurora.core.common.protos.PbRateDetails.
 * Use `create(PbRateDetailsSchema)` to create a new message.
 */
export const PbRateDetailsSchema: GenMessage<PbRateDetails> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 8);

/**
 * @generated from message aurora.core.common.protos.SettlementTransactionDetails
 */
export type SettlementTransactionDetails = Message<"aurora.core.common.protos.SettlementTransactionDetails"> & {
  /**
   * @generated from field: string cusip = 1;
   */
  cusip: string;

  /**
   * @generated from field: int64 quantity = 2;
   */
  quantity: bigint;

  /**
   * @generated from field: aurora.core.common.protos.PbDecimal amount = 3;
   */
  amount?: PbDecimal;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string recipient_of_message = 5;
   */
  recipientOfMessage: string;

  /**
   * @generated from field: string deliverer = 6;
   */
  deliverer: string;

  /**
   * @generated from field: string receiver = 7;
   */
  receiver: string;

  /**
   * received from DTCC, identifying this DO/PO operation
   *
   * @generated from field: string transaction_id = 8;
   */
  transactionId: string;

  /**
   * aurora defined id, identifying the contract operation resulting in this DO/PO operation
   *
   * @generated from field: optional string op_id = 9;
   */
  opId?: string;
};

/**
 * Describes the message aurora.core.common.protos.SettlementTransactionDetails.
 * Use `create(SettlementTransactionDetailsSchema)` to create a new message.
 */
export const SettlementTransactionDetailsSchema: GenMessage<SettlementTransactionDetails> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 9);

/**
 * @generated from message aurora.core.common.protos.ErrDetail
 */
export type ErrDetail = Message<"aurora.core.common.protos.ErrDetail"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message aurora.core.common.protos.ErrDetail.
 * Use `create(ErrDetailSchema)` to create a new message.
 */
export const ErrDetailSchema: GenMessage<ErrDetail> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 10);

/**
 * @generated from message aurora.core.common.protos.RateLimit
 */
export type RateLimit = Message<"aurora.core.common.protos.RateLimit"> & {
  /**
   * @generated from field: aurora.core.common.protos.RateType type = 1;
   */
  type: RateType;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message aurora.core.common.protos.RateLimit.
 * Use `create(RateLimitSchema)` to create a new message.
 */
export const RateLimitSchema: GenMessage<RateLimit> = /*@__PURE__*/
  messageDesc(file_common_protos_types, 11);

/**
 * @generated from enum aurora.core.common.protos.UserType
 */
export enum UserType {
  /**
   * @generated from enum value: UNKNOWN_TYPE = 0;
   */
  UNKNOWN_TYPE = 0,

  /**
   * @generated from enum value: SYSTEM = 1;
   */
  SYSTEM = 1,

  /**
   * @generated from enum value: BOT_USER = 2;
   */
  BOT_USER = 2,

  /**
   * @generated from enum value: TRADER = 3;
   */
  TRADER = 3,

  /**
   * @generated from enum value: EXTERNAL_TRADER = 5;
   */
  EXTERNAL_TRADER = 5,
}

/**
 * Describes the enum aurora.core.common.protos.UserType.
 */
export const UserTypeSchema: GenEnum<UserType> = /*@__PURE__*/
  enumDesc(file_common_protos_types, 0);

/**
 * @generated from enum aurora.core.common.protos.Currency
 */
export enum Currency {
  /**
   * @generated from enum value: UNSPECIFIED_CURRENCY = 0;
   */
  UNSPECIFIED_CURRENCY = 0,

  /**
   * @generated from enum value: USD = 1;
   */
  USD = 1,

  /**
   * @generated from enum value: CAD = 2;
   */
  CAD = 2,

  /**
   * @generated from enum value: GBP = 3;
   */
  GBP = 3,

  /**
   * @generated from enum value: EUR = 4;
   */
  EUR = 4,

  /**
   * @generated from enum value: JPY = 5;
   */
  JPY = 5,
}

/**
 * Describes the enum aurora.core.common.protos.Currency.
 */
export const CurrencySchema: GenEnum<Currency> = /*@__PURE__*/
  enumDesc(file_common_protos_types, 1);

/**
 * @generated from enum aurora.core.common.protos.RateType
 */
export enum RateType {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REBATE = 1;
   */
  REBATE = 1,

  /**
   * @generated from enum value: FEE = 2;
   */
  FEE = 2,
}

/**
 * Describes the enum aurora.core.common.protos.RateType.
 */
export const RateTypeSchema: GenEnum<RateType> = /*@__PURE__*/
  enumDesc(file_common_protos_types, 2);

/**
 * @generated from enum aurora.core.common.protos.PbTradingPermissions
 */
export enum PbTradingPermissions {
  /**
   * @generated from enum value: LENDER = 0;
   */
  LENDER = 0,

  /**
   * @generated from enum value: BORROWER = 1;
   */
  BORROWER = 1,

  /**
   * @generated from enum value: LENDER_OR_BORROWER = 2;
   */
  LENDER_OR_BORROWER = 2,

  /**
   * @generated from enum value: DISABLED = 3;
   */
  DISABLED = 3,
}

/**
 * Describes the enum aurora.core.common.protos.PbTradingPermissions.
 */
export const PbTradingPermissionsSchema: GenEnum<PbTradingPermissions> = /*@__PURE__*/
  enumDesc(file_common_protos_types, 3);

